import { InjectionToken } from '@angular/core';
import { StorageConfig } from '@ionic/storage';

export interface IIonicStorageConfig {
	VERSION: number;
}

export const IONIC_STORAGE_CONFIG_TOKEN = new InjectionToken<StorageConfig>('storage.config');
export const IONIC_STORAGE_CONFIG = {
	VERSION: 13,
} as IIonicStorageConfig;

// Default Database level config
export const MTProConfig = {
	name: 'MTPro',
	driverOrder: ['indexeddb', 'localstorage', 'sqlite'],
} as StorageConfig;

// Table configs
function newMTProTable(config?: StorageConfig): StorageConfig {
	return { ...MTProConfig, ...config };
}

// Regular tables
// Dynamic
export const AuthStorageConfig = newMTProTable({ name: 'MTProDynamic', storeName: 'auth' });
export const SyncStorageConfig = newMTProTable({ name: 'MTProDynamic', storeName: 'sync' });
export const AppointmentStorageConfig = newMTProTable({ name: 'MTProDynamic', storeName: 'appointments' });
export const AppointmentClearCodeStorageConfig = newMTProTable({ name: 'MTProDynamic', storeName: 'appointmentClearCode' });
export const TimeEntryStorageConfig = newMTProTable({ name: 'MTProDynamic', storeName: 'timeEntries' });
export const TruckInventoryStorageConfig = newMTProTable({ name: 'MTProDynamic', storeName: 'truckInventory' });
export const PendingTicketProvisionsConfig = newMTProTable({ name: 'MTProDynamic', storeName: 'pendingTicketProvisions' });

// Config
export const SystemStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'system' });
export const AdditionalChargesStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'additionalCharges' });
export const TicketStatusTransitionsStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'ticketStatusTransitions' });
export const TicketClearCodeTypesStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'ticketClearCodeTypes' });
export const TicketClearCodeOptionsStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'ticketClearCodeOptions' });
export const TicketClearCodeAllowedStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'ticketClearCodeAllowed' });
export const TimeCodesStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'timeCodes' });
export const PayCodesStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'payCodes' });
export const ConfigSettingsStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'configSettings' });
export const EquipmentAttributesStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'equipmentAttributes' });
export const EquipmentCategoriesStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'equipmentCategories' });
export const InventoryStatusesStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'inventoryStatuses' });
export const InventoryRemovalReasonsStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'inventoryRemovalReasons' });
export const FormsStorageConfig = newMTProTable({ name: 'MTProConfiguration', storeName: 'forms' });

// Failed Request tables
export const FailedRequestsStorageConfig = newMTProTable({ name: 'MTProFailedRequests', storeName: 'requests' });
